import { CoreActionTypes } from "./core-types"
import { Action, ActionCreator } from "redux"

export const setCurrentPageName: ActionCreator<Action> = (payload: string) => ({
  type: CoreActionTypes.SET_CURRENT_PAGE_NAME, payload
})

